export default "__VITE_ASSET__CetPlsyt__"